import { List, ListType, Media } from '@epicuro-next/models/engagement';
import { createAction, props } from '@ngrx/store';
import { Product } from 'graphql-api/gql-api-interfaces';

import { ICreateListWithProducts } from '../../models';
import { ListItem } from '../../models/list-item';

/**
 * Action for creating an active list
 */
export const generateList = createAction(
  '[ProductList] Create Active List',
  props<{ products: Product[] }>(),
);

/**
 * Action for creating a list
 */
export const createList = createAction(
  '[ProductList] Create List',
  props<{
    list: Partial<List> & Pick<List, 'name'>;
    media?: Partial<Media> | null;
  }>(),
);

export const createListSuccess = createAction(
  '[ProductList] Create List success',
  props<{ list: List }>(),
);

export const createCommercialListSuccess = createAction(
  '[ProductList] Create Commercial List success',
  props<{ list: List }>(),
);

export const createListError = createAction(
  '[ProductList] Create List error',
  props<{ error: string }>(),
);

/**
 * Action for creating a list
 */
export const createListWithProducts = createAction(
  '[ProductList] Create List With Products',
  props<ICreateListWithProducts>(),
);

export const setListItemsInPreparationToCreateList = createAction(
  '[ProductList] Set List Items In Preparation To Create List',
  props<{ listItems: ListItem[]; listType: ListType }>(),
);

export const clearListItemsInPreparationToCreateList = createAction(
  '[ProductList] Clear List Items In Preparation To Create List',
);
